import { Grid, Typography } from "@mui/material";
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseBox from "../../base/BaseBox/baseBox";
import { ICO_REGISTRY_TABLE_FIELDS_CONFIG } from "../../../page/IcoRegistryPage/PageTablesConfig";
import AgreementTable from "../../table/AgreementTable";

export default function RelatedAgreementsBox({ relatedAgreements, agreementType, hiddenColumnsForTables, columnsOrdersForTables }) {
    const { t } = useTranslation();


    return (
        <BaseBox>
            <Grid container spacing={1}>
                <Grid item sm={6} xs={6} textAlign={"start"} display={"flex"}>
                    <Typography
                        variant="subtitle2"
                        className="capitalize-first-letter"
                    >
                        {t(`other.related_agreements_box.related_agreements`)}
                    </Typography>
                </Grid>
                <Grid item sm={6} xs={6} />

                <Grid item xs={12}>

                    <AgreementTable
                        data={relatedAgreements}
                        hiddenColumns={hiddenColumnsForTables}
                        columnsOrders={columnsOrdersForTables}
                        style={{ maxHeight: "40vh" }}
                        tableConfig={ICO_REGISTRY_TABLE_FIELDS_CONFIG}
                        showCleanFilterIcon={true}
                        showContextMenu={false}
                        showExportToFileButton={false}
                        showDetailsIcon={false}
                        showCheckbox={false}
                        showFilters={false}

                    />
                </Grid>
            </Grid>
        </BaseBox>
    );
}

RelatedAgreementsBox.propTypes = {
    relatedAgreements: PropTypes.array,
    agreementType: PropTypes.string
}


RelatedAgreementsBox.defaultProps = {
    relatedAgreements: [],
    agreementType: "agreement"
}
